import React, { useEffect, useState, createRef } from 'react';
import Panel from "./Panel";
import LiveStreamPanel from "./LiveStreamPanel";

export default ({ panels, selectedPanelID, isLiveStream }) => {
    const [elRefs, setElRefs] = useState([]);

    useEffect(() => {
        setElRefs(elRefs => (
            Array(panels.length).fill().map((_, i) => elRefs[i] || createRef())
        ));
    }, [panels]);

    useEffect(() => {
        const foundIndex = panels.findIndex(panel => panel.id === selectedPanelID);
        if (foundIndex >= 0) {
            elRefs[foundIndex].current.scrollIntoView({
                behavior: "smooth",
            })
        }
    }, [selectedPanelID]);

    return (
        <div className="card-grid">
            {panels.map((panel, i) => (
                isLiveStream ? (
                    <LiveStreamPanel
                        key={'panel-' + panel.id}
                        panel={panel}
                    />
                ) : (
                    <Panel
                        key={'panel-' + panel.id}
                        panel={panel}
                    />
                )
            ))}
        </div>
    )
}
